import React from 'react'

import Banner from '../../components/Banner/Banner'
import Healthcare from '../../components/Healthcare/Healthcare'
import Works from '../../components/Works/Works'
import Surgical from '../../components/Surgical/Surgical'
import Support from '../../components/Support/Support'
import Respond from '../../components/Respond/Respond'
import Footer from '../../Shared/Footer/Footer'
import Questions from '../../Questions/Questions'
import AnimatedCard from '../../components/AnimatedCard/AnimatedCard'
import Header from '../../Shared/Header/Header'
export default function Home() {
  return (
    <div>
      <div className="home">
        <Header/>
        <Banner/>
        <Works/>
        <Healthcare/>
        <Support/>
        <Surgical/>
        <Respond/>
        <AnimatedCard/>
        <Questions/>
        <Footer/>
      </div>
    </div>
  )
}
